import { render, staticRenderFns } from "./SubfamilyCreate.vue?vue&type=template&id=fd8a4fd8&lang=pug&"
import script from "./SubfamilyCreate.vue?vue&type=script&lang=js&"
export * from "./SubfamilyCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubfamilyCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubfamilyCreate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
